if (!customElements.get('ayo-header')) {
  class AyoHeader extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[data-ayo-bar]');
      this.drawer = this.querySelector('[data-ayo-drawer]');
      this.panel = this.drawer && this.drawer.querySelector('[role="dialog"]');
      this.openBtn = this.querySelector('[data-ayo-open]');

      this.onScroll = this.onScroll.bind(this);
      this.onKey = this.onKey.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();

      if (this.openBtn) this.openBtn.addEventListener('click', () => this.open());
      this.querySelectorAll('[data-ayo-close]').forEach((el) => el.addEventListener('click', () => this.close()));

      this.setupDuo();
      this.setupSearch();
      this.setupMenu();
    }

    /* ---------- Menu sheet (story rings) ---------- */
    setupMenu() {
      this.menu = this.querySelector('[data-ayo-menu]');
      if (!this.menu) return;
      this.menu.addEventListener('click', (e) => {
        const open = e.target.closest('[data-ayo-sub-open]');
        if (open) {
          this.markSeen(open.dataset.ayoRing);
          this.openSub(open.dataset.ayoSubOpen);
          return;
        }
        if (e.target.closest('[data-ayo-sub-back]')) { this.closeSub(); return; }
        const ring = e.target.closest('a[data-ayo-ring]');
        if (ring) this.markSeen(ring.dataset.ayoRing);
      });
      const grab = this.menu.querySelector('[data-ayo-menu-grab]');
      if (grab) this.makeSwipe(grab, this.menu, () => this.close());
      // other elements (e.g. the mobile bottom bar) can open the menu
      this.onMenuTrigger = (e) => {
        const t = e.target.closest('[data-ayo-menu-open]');
        if (!t || this.contains(t)) return;
        e.preventDefault();
        this.open();
      };
      document.addEventListener('click', this.onMenuTrigger);
    }

    openSub(id) {
      const sub = this.menu.querySelector(`[data-ayo-sub="${id}"]`);
      if (!sub) return;
      this.menu.querySelectorAll('[data-ayo-sub]').forEach((v) => { if (v !== sub) { v.hidden = true; v.classList.remove('is-in'); } });
      sub.hidden = false;
      void sub.offsetWidth;
      sub.classList.add('is-in');
      this.menu.classList.add('has-sub');
      const back = sub.querySelector('[data-ayo-sub-back]');
      if (back) setTimeout(() => back.focus({ preventScroll: true }), 60);
    }

    closeSub(instant) {
      const sub = this.menu && this.menu.querySelector('[data-ayo-sub].is-in');
      if (!this.menu) return;
      this.menu.classList.remove('has-sub');
      if (!sub) return;
      sub.classList.remove('is-in');
      if (instant) sub.hidden = true;
      else setTimeout(() => { if (!sub.classList.contains('is-in')) sub.hidden = true; }, 380);
    }

    readSeen() {
      try { return JSON.parse(localStorage.getItem('ayo-rings-seen') || '[]'); } catch (e) { return []; }
    }

    markSeen(key) {
      if (!key) return;
      const seen = this.readSeen();
      if (!seen.includes(key)) {
        seen.push(key);
        try { localStorage.setItem('ayo-rings-seen', JSON.stringify(seen.slice(-50))); } catch (e) { /* storage unavailable */ }
      }
      this.paintRings();
    }

    paintRings() {
      if (!this.menu) return;
      const seen = this.readSeen();
      this.menu.querySelectorAll('[data-ayo-ring]').forEach((r) => r.classList.toggle('is-seen', seen.includes(r.dataset.ayoRing)));
    }

    paintWishCount() {
      const el = this.menu && this.menu.querySelector('[data-ayo-wish-count]');
      if (!el) return;
      let n = 0;
      try { n = Object.keys(JSON.parse(localStorage.getItem('productDataWishlist') || '{}')).length; } catch (e) { n = 0; }
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
    }

    makeSwipe(handle, sheet, onClose) {
      let startY = null;
      let dy = 0;
      const move = (e) => {
        if (startY === null) return;
        dy = Math.max(0, e.clientY - startY);
        sheet.style.transform = `translateY(${dy}px)`;
      };
      const end = () => {
        if (startY === null) return;
        startY = null;
        sheet.classList.remove('is-dragging');
        sheet.style.transform = '';
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', end);
        window.removeEventListener('pointercancel', end);
        if (dy > 90) onClose();
        dy = 0;
      };
      handle.addEventListener('pointerdown', (e) => {
        startY = e.clientY;
        dy = 0;
        sheet.classList.add('is-dragging');
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', end);
        window.addEventListener('pointercancel', end);
      });
    }

    /* ---------- Search panel ---------- */
    setupSearch() {
      this.search = this.querySelector('[data-ayo-search]');
      if (!this.search) return;
      this.searchBtn = this.querySelector('[data-ayo-search-open]');
      this.searchInput = this.search.querySelector('[data-ayo-search-input]');
      this.searchForm = this.search.querySelector('[data-ayo-search-form]');
      this.searchClear = this.search.querySelector('[data-ayo-search-clear]');
      this.searchIdle = this.search.querySelector('[data-ayo-search-idle]');
      this.searchResults = this.search.querySelector('[data-ayo-search-results]');
      this.recentBlock = this.search.querySelector('[data-ayo-recent]');
      this.recentList = this.search.querySelector('[data-ayo-recent-list]');
      this.liveEnabled = this.search.dataset.live === 'true';
      this.suggestUrl = this.search.dataset.sectionUrl || '/search/suggest';
      this.restingItem = this.duo && this.duo.querySelector('.ayo-hd__duo-item.is-active');
      this.onSearchKey = this.onSearchKey.bind(this);

      // Any element with data-ayo-search-open (header button, footer sticky nav) opens the sheet
      this.onSearchTrigger = (e) => {
        const trigger = e.target.closest('[data-ayo-search-open]');
        if (!trigger) return;
        e.preventDefault();
        this.openSearch();
      };
      document.addEventListener('click', this.onSearchTrigger);
      this.setupSearchSwipe();
      this.search.querySelectorAll('[data-ayo-search-close]').forEach((el) => el.addEventListener('click', () => this.closeSearch()));

      let timer;
      this.searchInput.addEventListener('input', () => {
        const q = this.searchInput.value.trim();
        this.searchClear.hidden = q.length === 0;
        clearTimeout(timer);
        timer = setTimeout(() => this.suggest(q), 250);
      });
      this.searchClear.addEventListener('click', () => {
        this.searchInput.value = '';
        this.searchClear.hidden = true;
        this.suggest('');
        this.searchInput.focus();
      });
      this.searchForm.addEventListener('submit', (e) => {
        const q = this.searchInput.value.trim();
        if (!q) { e.preventDefault(); return; }
        const mapped = this.translate(q);
        if (mapped) this.searchInput.value = mapped;
        this.saveRecent(q);
        this.track(mapped || q);
      });
      this.search.addEventListener('click', (e) => {
        const term = e.target.closest('[data-ayo-term]');
        if (term) { this.saveRecent(term.dataset.ayoTerm); this.track(term.dataset.ayoTerm); }
      });
      const clearRecent = this.search.querySelector('[data-ayo-recent-clear]');
      if (clearRecent) clearRecent.addEventListener('click', () => { this.writeRecent([]); this.renderRecent(); });

      this.cfg = {};
      try { this.cfg = JSON.parse(this.search.querySelector('[data-ayo-search-config]').textContent); } catch (e) { this.cfg = {}; }
      this.synonyms = this.parseSynonyms(this.cfg.synonyms || '');
      this.budgets = this.parseBudgets(this.cfg.budgets || '');
      this.tracked = new Set();
      this.recordViewed();
      this.setupVoice();
      this.search.addEventListener('click', (e) => this.onSearchClick(e));
    }

    /* ---------- Arabic / misspelling translation ---------- */
    normalize(str) {
      return (str || '')
        .toLowerCase()
        .replace(/[\u064B-\u0652\u0640]/g, '')
        .replace(/[أإآ]/g, 'ا')
        .replace(/ة/g, 'ه')
        .replace(/ى/g, 'ي')
        .replace(/\s+/g, ' ')
        .trim();
    }

    parseSynonyms(text) {
      const map = new Map();
      text.split(/\r?\n/).forEach((line) => {
        const parts = line.split('=');
        if (parts.length < 2) return;
        const target = parts.slice(1).join('=').trim();
        if (!target) return;
        parts[0].split(',').forEach((w) => {
          const key = this.normalize(w);
          if (key) map.set(key, target);
        });
      });
      // longest phrases first so "نيو بالانس" wins over single words
      return new Map([...map.entries()].sort((a, b) => b[0].length - a[0].length));
    }

    translate(q) {
      if (!this.synonyms || !this.synonyms.size) return null;
      const n = this.normalize(q);
      if (!n) return null;
      if (this.synonyms.has(n)) return this.synonyms.get(n);
      let out = ` ${n} `;
      let changed = false;
      this.synonyms.forEach((target, key) => {
        const needle = ` ${key} `;
        if (out.includes(needle)) {
          out = out.split(needle).join(` ${target} `);
          changed = true;
        }
      });
      return changed ? out.trim() : null;
    }

    /* ---------- Filters ---------- */
    parseBudgets(text) {
      return text.split(/\r?\n/).map((line) => {
        const [label, range] = line.split('|').map((x) => (x || '').trim());
        if (!label || !range) return null;
        const [from, to] = range.split('-').map((x) => x.trim());
        const min = from === '' ? 0 : parseFloat(from);
        const max = to === '' || to === undefined ? null : parseFloat(to);
        if (Number.isNaN(min)) return null;
        return { label, min, max };
      }).filter(Boolean);
    }

    buildFilters() {
      const box = this.searchResults.querySelector('[data-ayo-filters]');
      const items = this.searchResults.querySelectorAll('.ayo-search__item');
      if (!box || items.length < 2) return;
      this.filterState = { budget: -1, stock: false, size: '' };
      const row = document.createElement('div');
      row.className = 'ayo-search__chips';
      const chip = (label, key) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'ayo-search__chip';
        b.dataset.ayoChip = key;
        b.textContent = label;
        b.setAttribute('aria-pressed', key === 'all' ? 'true' : 'false');
        row.appendChild(b);
      };
      chip(this.cfg.allLabel || 'All', 'all');
      this.budgets.forEach((bd, i) => chip(bd.label, `b${i}`));
      if (this.cfg.inStockLabel) chip(this.cfg.inStockLabel, 'stock');
      box.appendChild(row);
      // Size buttons: only products that have the size in stock stay in the list.
      const sizes = String(this.cfg.sizes || '').split(',').map((x) => x.trim()).filter(Boolean);
      if (sizes.length) {
        const sizeRow = row.cloneNode(false);
        sizeRow.classList.add('ayo-search__chips--sizes');
        box.appendChild(sizeRow);
        sizes.forEach((z) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'ayo-search__chip ayo-search__chip--size';
          b.dataset.ayoChip = `s:${z}`;
          b.textContent = z;
          b.setAttribute('aria-pressed', 'false');
          sizeRow.appendChild(b);
        });
      }
    }

    onChip(btn) {
      const key = btn.dataset.ayoChip;
      if (key === 'all') this.filterState = { budget: -1, stock: false, size: '' };
      else if (key === 'stock') this.filterState.stock = !this.filterState.stock;
      else if (key.startsWith('s:')) { const z = key.slice(2); this.filterState.size = this.filterState.size === z ? '' : z; }
      else {
        const i = parseInt(key.slice(1), 10);
        this.filterState.budget = this.filterState.budget === i ? -1 : i;
      }
      const st = this.filterState;
      this.searchResults.querySelectorAll('[data-ayo-chip]').forEach((c) => {
        const k = c.dataset.ayoChip;
        const on = k === 'all' ? (st.budget === -1 && !st.stock && !st.size) : k === 'stock' ? st.stock : k.startsWith('s:') ? st.size === k.slice(2) : st.budget === parseInt(k.slice(1), 10);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.applyFilters();
    }

    applyFilters() {
      const st = this.filterState;
      if (!st) return;
      const bd = st.budget >= 0 ? this.budgets[st.budget] : null;
      let visible = 0;
      this.searchResults.querySelectorAll('.ayo-search__item').forEach((li) => {
        const price = parseInt(li.dataset.price, 10) / 100;
        const okBudget = !bd || (price >= bd.min && (bd.max === null || price <= bd.max));
        const okStock = !st.stock || li.dataset.available === 'true';
        const okSize = !st.size || (li.dataset.sizes || '').indexOf(`,${st.size},`) > -1;
        const show = okBudget && okStock && okSize;
        li.hidden = !show;
        if (show) visible += 1;
      });
      const empty = this.searchResults.querySelector('[data-ayo-filter-empty]');
      if (empty) {
        empty.hidden = visible > 0;
        empty.textContent = this.cfg.filterEmpty || '';
      }
      const all = this.searchResults.querySelector('[data-ayo-all]');
      if (all) {
        const url = new URL(all.getAttribute('href'), window.location.origin);
        url.searchParams.delete('filter.v.price.gte');
        url.searchParams.delete('filter.v.price.lte');
        url.searchParams.delete('filter.v.availability');
        if (this.cfg.sizeParam) url.searchParams.delete(this.cfg.sizeParam);
        if (bd) {
          url.searchParams.set('filter.v.price.gte', bd.min);
          if (bd.max !== null) url.searchParams.set('filter.v.price.lte', bd.max);
        }
        if (st.stock) url.searchParams.set('filter.v.availability', '1');
        if (st.size && this.cfg.sizeParam) url.searchParams.set(this.cfg.sizeParam, st.size);
        all.setAttribute('href', url.pathname + url.search);
      }
    }

    /* ---------- Results enhancements ---------- */
    enhanceResults(original, query, mapped) {
      const r = this.searchResults;
      if (mapped) {
        const note = document.createElement('p');
        note.className = 'ayo-search__note';
        note.append(`${this.cfg.showingFor || 'Showing results for'} `);
        const b = document.createElement('b');
        b.textContent = mapped;
        note.appendChild(b);
        r.prepend(note);
      }
      const words = query.split(/\s+/).filter((w) => w.length > 1).map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      if (words.length) {
        const re = new RegExp(`(${words.join('|')})`, 'gi');
        r.querySelectorAll('[data-ayo-title]').forEach((el) => {
          const text = el.textContent;
          el.textContent = '';
          text.split(re).forEach((part, i) => {
            if (i % 2 === 1) {
              const m = document.createElement('mark');
              m.textContent = part;
              el.appendChild(m);
            } else if (part) el.appendChild(document.createTextNode(part));
          });
        });
      }
      const limit = parseInt(this.cfg.lowStock, 10) || 0;
      r.querySelectorAll('.ayo-search__item[data-left]').forEach((li) => {
        const left = parseInt(li.dataset.left, 10);
        const el = li.querySelector('[data-ayo-left]');
        if (el && left > 0 && left <= limit) {
          el.textContent = (this.cfg.lowStockLabel || 'Only [count] left').replace('[count]', left);
          el.hidden = false;
        }
      });
      this.buildFilters();
      const empty = r.querySelector('[data-ayo-empty]');
      if (empty) {
        if (this.cfg.whatsapp) {
          const a = document.createElement('a');
          a.className = 'ayo-search__wa';
          a.href = `https://wa.me/${this.cfg.whatsapp}?text=${encodeURIComponent(`${this.cfg.whatsappMessage || ''} ${original}`.trim())}`;
          a.target = '_blank';
          a.rel = 'noopener';
          a.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2Zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.2.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.5-.3Z"/></svg>';
          const span = document.createElement('span');
          span.textContent = this.cfg.whatsappLabel || 'WhatsApp';
          a.appendChild(span);
          empty.appendChild(a);
        }
        this.searchIdle.hidden = false;
      }
    }

    onSearchClick(e) {
      const chip = e.target.closest('[data-ayo-chip]');
      if (chip) { this.onChip(chip); return; }
      const size = e.target.closest('.ayo-search__size');
      if (size && !size.disabled) {
        size.closest('.ayo-search__sizes').querySelectorAll('.ayo-search__size').forEach((b) => b.setAttribute('aria-pressed', b === size ? 'true' : 'false'));
        const msg = size.closest('[data-ayo-quick]').querySelector('[data-ayo-quick-msg]');
        if (msg) msg.hidden = true;
        return;
      }
      const add = e.target.closest('[data-ayo-quick-add]');
      if (add) { this.quickAdd(add); return; }
      const link = e.target.closest('[data-ayo-product-link]');
      if (link) this.track(this.searchInput.value.trim());
    }

    /* ---------- Quick add ---------- */
    async quickAdd(btn) {
      const wrap = btn.closest('[data-ayo-quick]');
      const msg = wrap.querySelector('[data-ayo-quick-msg]');
      const picked = wrap.querySelector('.ayo-search__size[aria-pressed="true"]');
      const say = (text, ok) => { msg.textContent = text; msg.hidden = false; msg.classList.toggle('is-ok', !!ok); };
      if (!picked) { say(this.cfg.pickSize || 'Pick your size first', false); return; }
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const fd = new FormData();
      fd.append('id', picked.dataset.variantId);
      fd.append('quantity', '1');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        fd.append('sections', cart.getSectionsToRender().map((x) => x.id));
        fd.append('sections_url', window.location.pathname);
      }
      try {
        const res = await fetch(this.cfg.cartAddUrl || '/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        });
        const data = await res.json();
        if (data.status) { say(data.description || this.cfg.addError, false); return; }
        say(this.cfg.added || 'Added', true);
        this.track(this.searchInput.value.trim());
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ayo-search', productVariantId: picked.dataset.variantId, cartData: data });
        }
        if (cart && typeof cart.renderContents === 'function') {
          // the drawer must lose its empty state before rendering, as product-form.js does
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          setTimeout(() => { this.closeSearch(); cart.renderContents(data); }, 500);
        } else {
          const bubble = await fetch(`${window.location.pathname}?section_id=cart-icon-bubble`).then((r) => r.text());
          const doc = new DOMParser().parseFromString(bubble, 'text/html');
          const sec = doc.querySelector('.shopify-section') || doc.body;
          if (this.cartLink) this.cartLink.innerHTML = sec.innerHTML;
        }
      } catch (err) {
        say(this.cfg.addError || 'Error', false);
      } finally {
        btn.classList.remove('is-loading');
      }
    }

    /* ---------- Recently viewed products ---------- */
    recordViewed() {
      const el = document.querySelector('[data-ayo-current-product]');
      if (!el) return;
      try {
        const p = JSON.parse(el.textContent);
        if (!p || !p.url) return;
        this.currentUrl = p.url;
        let list = JSON.parse(localStorage.getItem('ayo-viewed') || '[]');
        list = list.filter((x) => x && x.url !== p.url);
        list.unshift(p);
        localStorage.setItem('ayo-viewed', JSON.stringify(list.slice(0, 10)));
      } catch (e) { /* storage unavailable */ }
    }

    renderViewed() {
      const block = this.search.querySelector('[data-ayo-viewed]');
      const box = this.search.querySelector('[data-ayo-viewed-list]');
      if (!block || !box) return;
      let list = [];
      try { list = JSON.parse(localStorage.getItem('ayo-viewed') || '[]'); } catch (e) { list = []; }
      list = list.filter((x) => x && x.url && x.url !== this.currentUrl).slice(0, 8);
      box.textContent = '';
      list.forEach((p) => {
        const a = document.createElement('a');
        a.className = 'ayo-search__viewed-item';
        a.href = p.url;
        a.title = p.title || '';
        const img = document.createElement('span');
        img.className = 'ayo-search__viewed-img';
        if (p.image) {
          const i = document.createElement('img');
          i.src = p.image;
          i.alt = p.title || '';
          i.loading = 'lazy';
          i.width = 120;
          i.height = 120;
          img.appendChild(i);
        }
        const price = document.createElement('span');
        price.className = 'ayo-search__viewed-price';
        price.textContent = p.price || '';
        a.append(img, price);
        box.appendChild(a);
      });
      block.hidden = list.length === 0;
    }

    /* ---------- Voice search ---------- */
    setupVoice() {
      const mic = this.search.querySelector('[data-ayo-mic]');
      const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!mic || !SR) return;
      mic.hidden = false;
      mic.addEventListener('click', () => {
        if (this.recognition) { this.recognition.stop(); return; }
        const rec = new SR();
        this.recognition = rec;
        rec.lang = this.cfg.voiceLang || 'ar-EG';
        rec.interimResults = false;
        rec.maxAlternatives = 1;
        const placeholder = this.searchInput.placeholder;
        this.searchInput.placeholder = this.cfg.listening || 'Listening...';
        mic.classList.add('is-listening');
        rec.onresult = (ev) => {
          const text = ev.results[0][0].transcript;
          this.searchInput.value = text;
          this.searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        };
        rec.onend = () => {
          mic.classList.remove('is-listening');
          this.searchInput.placeholder = placeholder;
          this.recognition = null;
        };
        rec.onerror = rec.onend;
        try { rec.start(); } catch (e) { rec.onend(); }
      });
    }

    /* ---------- Tracking: Meta Pixel, GA4, Shopify custom pixel ---------- */
    track(term) {
      const t = (term || '').trim();
      if (t.length < 2 || this.tracked.has(t.toLowerCase())) return;
      this.tracked.add(t.toLowerCase());
      try { if (typeof window.fbq === 'function') window.fbq('track', 'Search', { search_string: t }); } catch (e) { /* pixel missing */ }
      try { if (typeof window.gtag === 'function') window.gtag('event', 'search', { search_term: t }); } catch (e) { /* ga missing */ }
      try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('ayo_search', { search_term: t }); } catch (e) { /* not available */ }
    }

    setupSearchSwipe() {
      const panel = this.search.querySelector('.ayo-search__panel');
      const grab = this.search.querySelector('[data-ayo-search-grab]');
      if (!panel || !grab) return;
      let startY = null;
      let dy = 0;
      const move = (e) => {
        if (startY === null) return;
        dy = Math.max(0, e.clientY - startY);
        panel.style.transform = `translateY(${dy}px)`;
      };
      const end = () => {
        if (startY === null) return;
        startY = null;
        panel.style.transition = '';
        panel.style.transform = '';
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', end);
        window.removeEventListener('pointercancel', end);
        if (dy > 90) this.closeSearch();
        dy = 0;
      };
      grab.addEventListener('pointerdown', (e) => {
        if (window.matchMedia('(min-width: 990px)').matches) return;
        startY = e.clientY;
        dy = 0;
        panel.style.transition = 'none';
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', end);
        window.addEventListener('pointercancel', end);
      });
    }

    openSearch() {
      if (!this.search.hidden && this.search.classList.contains('is-open')) return;
      if (this.drawer && !this.drawer.hidden) this.close();
      this.search.hidden = false;
      this.searchTrigger = document.activeElement;
      // focus synchronously inside the tap so phones open the keyboard
      this.searchInput.focus({ preventScroll: true });
      if (typeof trapFocus === 'function') trapFocus(this.search, this.searchInput);
      requestAnimationFrame(() => this.search.classList.add('is-open'));
      document.documentElement.classList.add('ayo-lock');
      this.searchBtn && this.searchBtn.setAttribute('aria-expanded', 'true');
      if (this.searchBtn) this.activate(this.searchBtn);
      this.renderRecent();
      this.renderViewed();
      this.tracked = new Set();
      document.addEventListener('keydown', this.onSearchKey);
    }

    closeSearch() {
      document.dispatchEvent(new CustomEvent('ayo:search-close'));
      this.search.classList.remove('is-open');
      document.documentElement.classList.remove('ayo-lock');
      this.searchBtn && this.searchBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', this.onSearchKey);
      if (this.restingItem) this.activate(this.restingItem);
      this.searchInput.blur();
      if (typeof removeTrapFocus === 'function') {
        const back = this.searchTrigger && this.searchTrigger.isConnected && this.searchTrigger.offsetParent !== null ? this.searchTrigger : null;
        removeTrapFocus(back);
      }
      setTimeout(() => { if (!this.search.classList.contains('is-open')) this.search.hidden = true; }, 300);
    }

    onSearchKey(e) {
      if (e.key === 'Escape') this.closeSearch();
    }

    async suggest(q) {
      if (this.abort) this.abort.abort();
      clearTimeout(this.trackTimer);
      if (!this.liveEnabled || q.length < 2) {
        this.searchResults.innerHTML = '';
        this.searchResults.classList.remove('is-loading');
        this.searchIdle.hidden = false;
        return;
      }
      this.abort = new AbortController();
      const ctrl = this.abort;
      this.searchResults.classList.add('is-loading');
      try {
        const mapped = this.translate(q);
        const query = mapped || q;
        const url = `${this.suggestUrl}?q=${encodeURIComponent(query)}&resources[type]=product,query&resources[limit]=10&resources[options][unavailable_products]=last&section_id=ayo-predictive-search`;
        const res = await fetch(url, { signal: ctrl.signal });
        if (!res.ok) throw new Error(res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const wrap = doc.querySelector('#shopify-section-ayo-predictive-search');
        const inner = (wrap ? wrap.innerHTML : doc.body.innerHTML).trim();
        if (this.searchInput.value.trim() !== q) return;
        this.searchResults.innerHTML = inner;
        this.searchIdle.hidden = inner.length > 0;
        this.filterState = null;
        if (inner.length) this.enhanceResults(q, query, mapped && this.normalize(mapped) !== this.normalize(q) ? mapped : null);
        this.trackTimer = setTimeout(() => { if (this.searchInput.value.trim() === q) this.track(query); }, 1500);
      } catch (err) {
        if (err.name === 'AbortError') return;
        this.searchResults.innerHTML = '';
        this.searchIdle.hidden = false;
      } finally {
        // an aborted request must not clear the spinner of the newer one
        if (this.abort === ctrl) this.searchResults.classList.remove('is-loading');
      }
    }

    readRecent() {
      try { return JSON.parse(localStorage.getItem('ayo-recent-searches') || '[]').filter((t) => typeof t === 'string'); } catch (e) { return []; }
    }

    writeRecent(list) {
      try { localStorage.setItem('ayo-recent-searches', JSON.stringify(list)); } catch (e) { /* storage unavailable */ }
    }

    saveRecent(term) {
      const t = (term || '').trim();
      if (!t) return;
      const list = this.readRecent().filter((x) => x.toLowerCase() !== t.toLowerCase());
      list.unshift(t);
      this.writeRecent(list.slice(0, 5));
    }

    renderRecent() {
      if (!this.recentBlock) return;
      const list = this.readRecent();
      this.recentList.textContent = '';
      list.forEach((t) => {
        const a = document.createElement('a');
        a.className = 'ayo-search__tag';
        a.href = `${this.searchForm.getAttribute('action')}?q=${encodeURIComponent(t)}&options%5Bprefix%5D=last`;
        a.dataset.ayoTerm = t;
        a.textContent = t;
        this.recentList.appendChild(a);
      });
      this.recentBlock.hidden = list.length === 0;
    }

    setupDuo() {
      this.duo = this.querySelector('[data-ayo-duo]');
      if (!this.duo) return;
      this.glow = this.duo.querySelector('.ayo-hd__glow');
      this.cartLink = this.duo.querySelector('#cart-icon-bubble');

      this.duo.querySelectorAll('.ayo-hd__duo-item').forEach((item) => {
        if (!item.hasAttribute('data-ayo-search-open')) item.addEventListener('click', () => this.activate(item));
      });

      this.placeGlow = this.placeGlow.bind(this);
      window.addEventListener('resize', this.placeGlow);
      this.placeGlow();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.placeGlow);
      requestAnimationFrame(() => this.duo.classList.add('is-ready'));

      if (this.cartLink) {
        this.count = this.readCount();
        new MutationObserver(() => this.onCartChange()).observe(this.cartLink, { childList: true, subtree: true });
      }
    }

    activate(item) {
      this.duo.querySelectorAll('.ayo-hd__duo-item').forEach((el) => el.classList.toggle('is-active', el === item));
      this.placeGlow();
    }

    placeGlow() {
      if (!this.glow) return;
      const active = this.duo.querySelector('.ayo-hd__duo-item.is-active');
      if (!active) { this.glow.style.width = '0px'; return; }
      this.glow.style.left = `${active.offsetLeft}px`;
      this.glow.style.width = `${active.offsetWidth}px`;
    }

    readCount() {
      const el = this.cartLink.querySelector('.ayo-hd__count');
      return el ? parseInt(el.dataset.count, 10) || 0 : 0;
    }

    onCartChange() {
      const count = this.readCount();
      this.cartLink.classList.toggle('has-items', count > 0);
      if (count > this.count) {
        this.activate(this.cartLink);
        const el = this.cartLink.querySelector('.ayo-hd__count');
        if (el) {
          el.classList.remove('is-bump');
          void el.offsetWidth;
          el.classList.add('is-bump');
        }
      }
      this.count = count;
      this.placeGlow();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.placeGlow) window.removeEventListener('resize', this.placeGlow);
      document.removeEventListener('keydown', this.onKey);
      if (this.onSearchKey) document.removeEventListener('keydown', this.onSearchKey);
      if (this.onSearchTrigger) document.removeEventListener('click', this.onSearchTrigger);
      if (this.onMenuTrigger) document.removeEventListener('click', this.onMenuTrigger);
      document.documentElement.classList.remove('ayo-lock');
    }

    onScroll() {
      if (this.scrollRaf) return;
      this.scrollRaf = requestAnimationFrame(() => {
        this.scrollRaf = null;
        this.bar.classList.toggle('is-scrolled', window.scrollY > 10);
        const h = `${this.bar.offsetHeight + 20}px`;
        if (h !== this.lastHeaderHeight) {
          this.lastHeaderHeight = h;
          document.documentElement.style.setProperty('--header-height', h);
        }
      });
    }

    open() {
      if (this.search && !this.search.hidden) this.closeSearch();
      this.closeSub(true);
      this.paintRings();
      this.paintWishCount();
      this.drawer.hidden = false;
      requestAnimationFrame(() => this.drawer.classList.add('is-open'));
      document.documentElement.classList.add('ayo-lock');
      this.openBtn && this.openBtn.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', this.onKey);
      this.menuTrigger = document.activeElement;
      setTimeout(() => {
        if (typeof trapFocus === 'function') trapFocus(this.drawer, this.panel || undefined);
        else if (this.panel) this.panel.focus();
      }, 50);
    }

    close() {
      document.dispatchEvent(new CustomEvent('ayo:menu-close'));
      this.drawer.classList.remove('is-open');
      document.documentElement.classList.remove('ayo-lock');
      this.openBtn && this.openBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', this.onKey);
      // hide only if it was not reopened in the meantime
      setTimeout(() => { if (!this.drawer.classList.contains('is-open')) this.drawer.hidden = true; }, 350);
      const back = this.menuTrigger && this.menuTrigger.isConnected && this.menuTrigger.offsetParent !== null ? this.menuTrigger : this.openBtn;
      if (typeof removeTrapFocus === 'function') removeTrapFocus(back && back.offsetParent !== null ? back : null);
      else if (back) back.focus();
    }

    onKey(e) {
      if (e.key !== 'Escape') return;
      if (this.menu && this.menu.classList.contains('has-sub')) this.closeSub();
      else this.close();
    }
  }
  customElements.define('ayo-header', AyoHeader);
}
